import {makeStyles} from '@material-ui/core/styles'
import {useNavigate, useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import Paper from '@mui/material/Paper'
import ServicesTab from '../../../components/3modules/AccountImport/Services'

const ApproveLocationForm = () => {
    const classes = useStyles()
    const navigate = useNavigate()
    const id = useParams().id
    const [selectedClient, setSelectedClient] = useState(null)
    const [selectedLocation, setSelectedLocation] = useState(null)

    const onCancel = () => {
        navigate(`/adminDashboard`)
    }

    const onNext = () => {
        navigate(`/approveService/service/${id}`)
    }


    useEffect(()=>{
        const selectedLocationFromStorage = getItemFromSessionStorage('selectedLocation')
        if(selectedLocationFromStorage){
            setSelectedLocation(selectedLocationFromStorage)
        }

      const selectedClientFromStorage = getItemFromSessionStorage('selectedClient')
      if(selectedClientFromStorage){
        setSelectedClient(selectedClientFromStorage)
      }
    }, [])

    return (
        <Paper className={classes.root}>
            <ServicesTab onNextService={onNext} onCancel={onCancel} selectedLocation={selectedLocation} selectedClient={selectedClient}
                         disabled/>
        </Paper>
    )
}

export default ApproveLocationForm

const useStyles = makeStyles({
    root: {
        margin: '20px',
        marginLeft: '80px',
        padding: '20px',
        width: '100%'
    }
})
